import { render } from "./AiReportQuarterContainer.vue?vue&type=template&id=1973cd6a&scoped=true&ts=true"
import script from "./AiReportQuarterContainer.vue?vue&type=script&lang=ts"
export * from "./AiReportQuarterContainer.vue?vue&type=script&lang=ts"

import "./AiReportQuarterContainer.vue?vue&type=style&index=0&id=1973cd6a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1973cd6a"]])

export default __exports__